import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-scroll";
import {
  FcAbout,
  FcContacts,
  FcEngineering,
  FcHome,
  FcReading,
} from "react-icons/fc";
import { MdConstruction } from "react-icons/md";
import { AiFillCloseCircle } from "react-icons/ai";

import "./MobileNav.css";
const MobileNav = () => {
  const [open, setOpen] = useState(false);
  //handle open
  const handleOpen = () => {
    setOpen(!open);
  };

  // handle menu clicks
  const handleMenuClick = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="mobile-nav">
        <div className="mobile-nav-header">
          {open ? (
            <AiFillCloseCircle
              size={30}
              className="mobile-nav-icon"
              onClick={handleOpen}
            />
          ) : (
            <GiHamburgerMenu
              size={30}
              className="mobile-nav-icon"
              onClick={handleOpen}
            />
          )}

          <span className="mobile-nav-title">My Portfolio App </span>
        </div>
        {open && (
          <div className="mobile-nav-menu">
            <div className="nav-items">
              <div className="nav-item">
                <div className="nav-link ">
                  <Link
                    className="menulink"
                    to="home"
                    spy={true}
                    smooth={true}
                    offset={0}
                    onClick={handleMenuClick}
                  >
                    <FcHome size={18} />
                    Home
                  </Link>
                </div>
                <div className="nav-link">
                  <Link
                    className="menulink"
                    to="about"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-60}
                    onClick={handleMenuClick}
                  >
                    <FcAbout size={18} />
                    About
                  </Link>
                </div>

                <div className="nav-link">
                  <Link
                    to="tech"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-60}
                    onClick={handleMenuClick}
                  >
                    <FcEngineering size={18} />
                    Tech Stack
                  </Link>
                </div>
                <div className="nav-link">
                  <Link
                    to="education"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={0}
                    onClick={handleMenuClick}
                  >
                    <FcReading size={18} />
                    Education
                  </Link>
                </div>
                <div className="nav-link">
                  <Link
                    to="projects"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-30}
                    onClick={handleMenuClick}
                  >
                    <MdConstruction size={18} />
                    Projects
                  </Link>
                </div>
                <div className="nav-link ">
                  <Link
                    to="contact"
                    className="menulink"
                    spy={true}
                    // style={{ color: "white" }}
                    smooth={true}
                    offset={-80}
                    onClick={handleMenuClick}
                  >
                    <FcContacts size={18} />
                    Contact
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileNav;
